import { ChevronDown, Lock } from 'lucide-react'

import { buttonVariants } from '@/ui/button-variants'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/ui/dropdown-menu'

import {
  ASSISTANT_TIER_LABELS,
  ASSISTANT_TIERS,
  type AssistantTier,
} from '../../api/assistant-tier-api'

export function AssistantTierPicker({
  enabledTiers,
  tier,
  onTierChange,
  disabled,
}: {
  enabledTiers: AssistantTier[]
  tier: AssistantTier
  onTierChange: (tier: AssistantTier) => void
  disabled?: boolean
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={buttonVariants({ variant: 'ghost', className: 'text-muted-foreground' })}
        disabled={disabled}
      >
        <span className="sr-only">Assistant tier: </span>
        {ASSISTANT_TIER_LABELS[tier]}
        <ChevronDown className="size-3.5" aria-hidden />
      </DropdownMenuTrigger>
      <DropdownMenuContent side="top" className="w-56">
        <DropdownMenuRadioGroup
          aria-label="Assistant tier"
          value={tier}
          onValueChange={(value) => onTierChange(value as AssistantTier)}
        >
          {ASSISTANT_TIERS.map((option) => {
            const label = ASSISTANT_TIER_LABELS[option]
            if (enabledTiers.includes(option))
              return (
                <DropdownMenuRadioItem key={option} value={option} closeOnClick>
                  {label}
                </DropdownMenuRadioItem>
              )
            return (
              <DropdownMenuRadioItem
                key={option}
                value={option}
                disabled
                className="data-disabled:opacity-100"
              >
                <span className="flex flex-col gap-0.5">
                  <span className="flex items-center gap-1.5">
                    <Lock className="size-3" aria-hidden />
                    {label} <span className="sr-only">Locked.</span>
                  </span>
                  <span className="text-muted-foreground font-normal">
                    Contact your billing admin to turn on {label}.
                  </span>
                </span>
              </DropdownMenuRadioItem>
            )
          })}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
